export class TwoDimPlanModel {
    public buildingType: number;
    public isolationType: number;
    public roomHeight: number;
    public position: string;
}